// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3R1xi","Success":"Button_Success__2aHYG","Danger":"Button_Danger__2eBLA"};